import { trigger, state, style, transition, animate } from "@angular/animations";

export namespace CoreAnimations {

    export const bodyExpansion = trigger('bodyExpansion', [
        state('false', style({ height: '0px', visibility: 'hidden', opacity: 0 })),
        state('true', style({ height: '*', visibility: 'visible', opacity: 1 })),
        transition('true <=> false', animate('225ms cubic-bezier(0.4, 0, 0.2, 1)'))
    ]);

    export const indicatorRotate = trigger('indicatorRotate', [
        state('false', style({ transform: 'rotate(0deg)' })),
        state('true', style({ transform: 'rotate(180deg)' })),
        transition('true <=> false', animate('300ms ease-in-out'))
    ]);

    export const inOutAnimation = trigger(
        'inOutAnimation',
        [
            transition(
                ':enter',
                [
                    style({ height: 0, opacity: 0 }),
                    animate('225ms cubic-bezier(0.4, 0, 0.2, 1)',
                        style({ height: '*', opacity: 1 })
                    )
                ]
            ),
            transition(
                ':leave',
                [
                    style({ height: '*', opacity: 1 }),
                    animate('225ms cubic-bezier(0.4, 0, 0.2, 1)',
                        style({ height: 0, opacity: 0 })
                    )
                ]
            )
        ]
    );
}